import { EastRounded, FeedOutlined, InfoOutlined } from "@mui/icons-material";
import { Button } from "@mui/material";
import { isNil } from "lodash";
import { Suspense, useMemo } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import FlxGrid from "../../../../../_src_shared/components/layout/FlxGrid";
import RffDataRow from "../../../../../components/finalForm/shared/RffDataRow";
import Flx from "../../../../../components/layout/Flx";
import ScreenContent from "../../../../../components/layout/ScreenContent";
import LoadingFallback from "../../../../../components/LoadingFallback";
import TitledCard from "../../../../../components/ui/TitledCard";
import TitledGroup from "../../../../../components/ui/TitledGroup";
import { selectOptionsInterestCalcType } from "../../../../../constants/selectOptions/selectOptionsInterestCalcType";
import { selectOptionsLoanProductType } from "../../../../../constants/selectOptions/selectOptionsLoanProductType";
import { selectOptionsLoanPurpose } from "../../../../../constants/selectOptions/selectOptionsLoanPurpose";
import { selectOptionsPipelineType } from "../../../../../constants/selectOptions/selectOptionsPipelineType";

const SummaryTabLoanInformationCard = ({ baseUrl }) => {
  const navigate = useNavigate();

  return (
    <>
      <TitledCard
        title={"Loan Information Overview"}
        icon={<InfoOutlined />}
        variant="h3"
        sx={{ flexGrow: 1, flexShrink: 1, flexBasis: "820px" }}
        // headerSx={{ pt: 2 }}
      >
        <Suspense fallback={<LoadingFallback />}>
          <FlxGrid width="400px" gap={4}>
            <Flx column>
              <RffDataRow
                name="pipeline"
                label="Pipeline"
                type="select"
                topBorder
                options={selectOptionsPipelineType}
              />
              <RffDataRow
                name="loanProductType"
                label="Loan Product Type"
                type="select"
                options={selectOptionsLoanProductType}
              />
              <RffDataRow
                name="loanPurpose"
                label="Loan Purpose"
                type="select"
                options={selectOptionsLoanPurpose}
              />
              <RffDataRow
                name="expectedClosingDate"
                label="Expected Closing Date"
                type="date"
              />
            </Flx>

            <Flx column>
              <TermsRenderer />
            </Flx>
          </FlxGrid>

          <Flx end fw sx={{ mt: 2 }}>
            <Button
              variant="text"
              onClick={() => navigate(`${baseUrl}/loan-information`)}
              endIcon={<EastRounded className="thin" />}
            >
              Go to Loan Information
            </Button>
          </Flx>
        </Suspense>
      </TitledCard>
    </>
  );
};

const TermsRenderer = ({ cellValueSize, onUpdateFn }) => {
  const loanDrilldown = useSelector((state) => state.loanDrilldown);

  const pt = useMemo(
    () => loanDrilldown?.loanProductType,
    [loanDrilldown?.loanProductType]
  );

  const showHoldback = useMemo(() => {
    if (isNil(pt)) return false;

    if (
      pt === "Fix and Flip" ||
      pt === "Ground Up Construction" ||
      pt === "Vacant Land"
    ) {
      return true;
    }

    return false;
  }, [pt]);

  if (pt === "DSCR") {
    return (
      <>
        <RffDataRow
          topBorder
          cellValueSize={cellValueSize}
          name="outstandingLoanUpb"
          label="Outstanding Loan UPB"
          type="dollar"
        />
        <RffDataRow
          cellValueSize={cellValueSize}
          placeholder="—"
          name="interestRate"
          label="Interest Rate"
          type="percent"
        />
        <RffDataRow
          cellValueSize={cellValueSize}
          placeholder="—"
          name="interestCalcType"
          label="Interest Calc Type"
          type="select"
          options={selectOptionsInterestCalcType}
        />
      </>
    );
  }

  return (
    <>
      {showHoldback && (
        <RffDataRow
          topBorder
          cellValueSize={cellValueSize}
          placeholder="—"
          name="totalHoldback"
          label="Total Holdback"
          type="dollar"
        />
      )}
      <RffDataRow
        topBorder={!showHoldback}
        cellValueSize={cellValueSize}
        placeholder="—"
        name="interestRate"
        label="Interest Rate"
        type="percent"
      />
      <RffDataRow
        cellValueSize={cellValueSize}
        placeholder="—"
        name="interestCalcType"
        label="Interest Calc Type"
        type="select"
        options={selectOptionsInterestCalcType}
      />
    </>
  );
};

export default SummaryTabLoanInformationCard;
